import { render, staticRenderFns } from "./SelectPlanesTratamientoPaciente.vue?vue&type=template&id=d9fb4b08"
import script from "./SelectPlanesTratamientoPaciente.vue?vue&type=script&lang=js"
export * from "./SelectPlanesTratamientoPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports